module.exports = {
  ownerId: '11111111111111111111111111111111',
  contractId: 'Bwr4WHCPz5rFVAD87RqTs3izo4zpzwsEdKPWUT1NS1C7',
};
